import { render } from "./PatientTagListModal.vue?vue&type=template&id=6f62d179&scoped=true"
import script from "./PatientTagListModal.vue?vue&type=script&lang=js"
export * from "./PatientTagListModal.vue?vue&type=script&lang=js"

import "./PatientTagListModal.vue?vue&type=style&index=0&id=6f62d179&scoped=true&lang=css"
import "./PatientTagListModal.vue?vue&type=style&index=1&id=6f62d179&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f62d179"]])

export default __exports__